module.exports = __webpack_public_path__ + "static/media/footer_fb.4f8f4aa9.svg";